import { useContext, useCallback } from "react";
import {MobileContext} from "../index";

export function useRequestUrl() {
    const [context, updateContext] = useContext(MobileContext);
    const url = context.requestUrl;
    const setRequestUrl = useCallback(function (requestUrl) {
        updateContext(Object.assign({}, context, {
            requestUrl: requestUrl
        }));
        sessionStorage.setItem('AdminContext', JSON.stringify(Object.assign({}, context, {
            requestUrl: requestUrl
        })));
    }, [context, updateContext]);
    return [url, setRequestUrl];
}

export function useOpenPopup() {
    const [context, updateContext] = useContext(MobileContext);
    const openPopup = context.openPopup
    const setOpenPopup = useCallback(function (open) {
        updateContext(Object.assign({}, context, {
            openPopup: open
        }));
        sessionStorage.setItem('MobileContext', JSON.stringify(Object.assign({}, context, {
            openPopup: open
        })));
    }, [context, updateContext]);
    return [openPopup, setOpenPopup];
}

export function useOrgState() {
    const [context, updateContext] = useContext(MobileContext);
    const orgState = context.orgState;
    const setOrgState = useCallback(function (orgState) {
        updateContext(Object.assign({}, context, {
            orgState: orgState
        }));
        sessionStorage.setItem('MobileContext', JSON.stringify(Object.assign({}, context, {
            orgState: orgState
        })));
    }, [context, updateContext]);
    return [orgState, setOrgState];
}

export function useCourt() {
    const [context, updateContext] = useContext(MobileContext);
    const court = context.court;
    const setCourt = useCallback(function (court) {
        updateContext(Object.assign({}, context, {
            court: court
        }));
        sessionStorage.setItem('MobileContext', JSON.stringify(Object.assign({}, context, {
            court: court
        })));
    }, [context, updateContext]);
    return [court, setCourt];
}

export function useForwardingOrg() {
    const [context, updateContext] = useContext(MobileContext);
    const forwardingOrg = context.forwardingOrg;
    const setForwardingOrg = useCallback(function (org) {
        updateContext(Object.assign({}, context, {
            forwardingOrg: org
        }));
        sessionStorage.setItem('MobileContext', JSON.stringify(Object.assign({}, context, {
            forwardingOrg: org
        })));
    }, [context, updateContext]);
    return [forwardingOrg, setForwardingOrg];
}

export function useCaptchaKey() {
    const [context, updateContext] = useContext(MobileContext);
    const captchaKey = context.captchaKey;
    const setCaptchaKey = useCallback(function (clientKey) {
        updateContext(Object.assign({}, context, {
            captchaKey: clientKey
        }));
        sessionStorage.setItem('MobileContext', JSON.stringify(Object.assign({}, context, {
            captchaKey: clientKey
        })));
    }, [context, updateContext]);
    return [captchaKey, setCaptchaKey];
}
